import React, { useEffect, useState } from 'react';
import WebPopupType from './web_popup_type';
import SubscribePopup from './subscribe_popup';
import DownloadAppPopup from './download_app_popup';
import AllVideoPopup from './all_video_popup';
import { getApiClient, makeCancelTokenSource } from '../../api_client/get';

const SUBSCRIBE_ENABLED = true;
const ALL_VIDEO_ENABLED = true;
const DOWNLOAD_APP_ENABLED = false;

// webview mode
const minimal = new URLSearchParams(window.location.search).get('minimal');

const WebPopupDelegate = () => {
  const [webPopups, setWebPopups] = useState([]);

  useEffect(() => {
    const cancelTokenSource = makeCancelTokenSource();
    getApiClient().getAllWebPopups()
      .then(response => response.data.success && setWebPopups(response.data.web_popups));
    return () => cancelTokenSource.cancel();
  }, []);

  return (
    minimal !== 'true' &&
      webPopups.map(webPopup =>
        <div key={webPopup}>
          {webPopup.type === WebPopupType.SUBSCRIBE && SUBSCRIBE_ENABLED &&
            <SubscribePopup webPopup={webPopup} timeToAppear={webPopup.time_delay} />}
          {webPopup.type === WebPopupType.DOWNLOAD_APP && DOWNLOAD_APP_ENABLED &&
            <DownloadAppPopup />}
          {webPopup.type === WebPopupType.ALL_VIDEO && ALL_VIDEO_ENABLED &&
            <AllVideoPopup webPopup={webPopup} timeToAppear={webPopup.time_delay} />}
        </div>)
  );
};

export default WebPopupDelegate;
